import React from 'react';

const CheckoutSection = ({ children, className, title }) => (
  <div className={`checkout__section ${className ? className : ''}`}>
    {title && (
      <div className="checkout__section-header">
        <h3>{title}</h3>
      </div>
    )}
    {children}
  </div>
);

export default CheckoutSection;
